/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_Quests_TitleInputs */

const en_control_tools_quests_title = /** @type {(inputs: Control_Tools_Quests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quest Help`)
};

const zh_control_tools_quests_title = /** @type {(inputs: Control_Tools_Quests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任务卡点`)
};

/**
* | output |
* | --- |
* | "Quest Help" |
*
* @param {Control_Tools_Quests_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_quests_title = /** @type {((inputs?: Control_Tools_Quests_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_Quests_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_quests_title(inputs)
	return zh_control_tools_quests_title(inputs)
});
export { control_tools_quests_title as "control.tools.quests.title" }